export default "__VITE_ASSET__B_AS_MCv__"